/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import EditableLabel from 'react-inline-editing'

import InlineEdit from '../common/Editable'
import styles from './Table.module.scss'

/**
* @author zilahir
* @function Table
* */

const Table = props => {
	// eslint-disable-next-line no-unused-vars
	const { invoiceData } = props
	const [activeClass, setActiveClass] = useState(false)
	const [inActiveClass, setInactiveClass] = useState(false)

	function handleFocusOn(value, element) {
		if (value === element) {
			setActiveClass(true)
			setInactiveClass(true)
		}
	}
	function handleFocusOut(value, originalValue, attributaName) {
		setInactiveClass(false)
		if (value !== originalValue) {
			// TODO here the original text has changed
		}
		return attributaName
	}
	return (
		<div className={styles.tableContainer}>
			{
				invoiceData
					? (
						<table>
							<tbody>
								<tr>
									<th colSpan="8">
										<h1 className={styles.title}>
											számla
										</h1>
									</th>
								</tr>
								<tr>
									<td
										colSpan="4"
										className={classnames(
											styles.rightBorder,
											styles.bottomBorder,
										)}
									>
										<p className={styles.header}>
											szállító
										</p>
										<p className={styles.meta}>
											{
												Object.keys(invoiceData.supplier).map((element, index) => (
													<EditableLabel
														key={index}
														inputClassName={classnames(
															styles.textInput,
															activeClass ? styles.active : null,
														)}
														labelClassName={classnames(
															inActiveClass ? styles.inActive : null,
														)}
														text={invoiceData.supplier[element].value}
														onFocus={v => handleFocusOn(v, invoiceData.supplier[element], element)}
														onFocusOut={
															v => handleFocusOut(v, invoiceData.supplier[element], element)
														}
													/>
												))
											}
										</p>
									</td>
									<td
										colSpan="4"
										className={classnames(
											styles.bottomBorder,
										)}
									>
										<p className={styles.header}>
											vevő
										</p>
										<p className={styles.meta}>
											Tesztkereskedelmi kft.<br />
											7400, Budapest, Vár u. 1<br />
											Adószám: 992345679-12<br />
											Bankszámlaszám: 991212<br />
											tel.: 06 30 11 1212<br />
											www.valami.hu<br />
										</p>
									</td>
								</tr>
								<tr>
									<td
										className={classnames(
											styles.yellow,
											parseFloat(
												invoiceData.orderMeta.orderNumber.accuracy, 2,
											) < 0.7 ? styles.editable : null,
										)}
									>
										<p className={styles.content}>
											megrendelés száma
											<InlineEdit
												originalValue={invoiceData.orderMeta.orderNumber.value}
												keyValue="orderNumber"
											/>
										</p>
									</td>
									<td
										className={classnames(
											styles.yellow,
											parseFloat(
												invoiceData.orderMeta.payMethod.accuracy, 2,
											) < 0.7 ? styles.editable : null,
										)}
									>
										<p className={styles.content}>
											fizetés
											<InlineEdit
												originalValue={invoiceData.orderMeta.payMethod.value}
												keyValue="payMethod"
											/>
										</p>
									</td>
									<td
										colSpan="2"
										className={classnames(
											styles.yellow,
											parseFloat(
												invoiceData.orderMeta.fulfillmentDate.accuracy, 2,
											) < 0.7 ? styles.editable : null,
										)}
									>
										<p className={styles.content}>
											teljesítés időpontja
											<InlineEdit
												originalValue={invoiceData.orderMeta.fulfillmentDate.value}
												keyValue="fulfillmentDate"
											/>
										</p>
									</td>
									<td
										colSpan="2"
										className={classnames(
											styles.yellow,
											parseFloat(
												invoiceData.orderMeta.invoicedDate.accuracy, 2,
											) < 0.7 ? styles.editable : null,
										)}
									>
										<p className={styles.content}>
											teljesítés időpontja
											<InlineEdit
												originalValue={invoiceData.orderMeta.invoicedDate.value}
												keyValue="invoicedDate"
											/>
										</p>
									</td>
									<td
										colSpan="2"
										className={classnames(
											styles.yellow,
											parseFloat(
												invoiceData.orderMeta.dueDate.accuracy, 2,
											) < 0.7 ? styles.editable : null,
										)}
									>
										<p className={styles.content}>
											fizetési határidő
											<InlineEdit
												originalValue={invoiceData.orderMeta.dueDate.value}
												keyValue="dueDate"
											/>
										</p>
									</td>
								</tr>
								<tr
									className={classnames(
										styles.separator,
										styles.stripeBg,
									)}
								>
									<td colSpan="8">
										<p className={styles.subHead}>
											Egyéb adatok
										</p>
									</td>
								</tr>
								<tr
									className={styles.noPadding}
								>
									<td
										className={styles.yellow}
									>
										Megnevezés
									</td>
									<td
										className={styles.yellow}
									>
									ME
									</td>
									<td
										className={styles.yellow}
									>
										Menny.
									</td>
									<td
										className={styles.yellow}
									>
										Egységár
									</td>
									<td
										className={styles.yellow}
									>
										Nettó érték
									</td>
									<td
										className={styles.yellow}
									>
										Áfa(%)
									</td>
									<td
										className={styles.yellow}
									>
										Áfa érték
									</td>
									<td
										className={styles.yellow}
									>
										Bruttó érték
									</td>
								</tr>
								{
									invoiceData.items.map((currentItem, index) => (
										<tr
											className={classnames(
												styles.noPadding,
												styles.rightBorder,
											)}
										>
											<td
												className={classnames(
													parseFloat(
														currentItem.name.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.name.value}
													keyValue="name"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.quantity.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.quantity.value}
													keyValue="quantity"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.quantityAmount.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.quantityAmount.value}
													keyValue="quantityAmount"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.priceExcludeVat.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.priceExcludeVat.value}
													keyValue="priceExcludeVat"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.priceNetto.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.priceNetto.value}
													keyValue="priceNetto"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.vatPercentage.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.vatPercentage.value}
													keyValue="vatPercentage"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.vatValue.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.vatValue.value}
													keyValue="vatValue"
													index={index}
												/>
											</td>
											<td
												className={classnames(
													parseFloat(
														currentItem.priceBrutto.accuracy, 2,
													) < 0.7 ? styles.editable : null,
												)}
											>
												<InlineEdit
													originalValue={currentItem.priceBrutto.value}
													keyValue="priceBrutto"
													index={index}
												/>
											</td>
										</tr>
									))
								}
								<tr
									className={classnames(
										styles.yellow,
										styles.noPadding,
									)}
								>
									<td>Áfa</td>
									<td width="20%">Adóalap</td>
									<td>Áfa</td>
									<td>Bruttó</td>
									<td colSpan="2" />
									<td>Számlaérték:</td>
									<td>19800 Ft</td>
								</tr>
								<tr
									className={classnames(
										styles.yellow,
										styles.noPadding,
									)}
								>
									<td>27%</td>
									<td width="20%">19 800 Ft</td>
									<td>5346 Ft</td>
									<td>25146 Ft</td>
									<td colSpan="2" />
									<td>Áfa:</td>
									<td>5346 Ft</td>
								</tr>
								<tr
									className={classnames(
										styles.yellow,
										styles.final,
									)}
								>
									<td />
									<td />
									<td />
									<td />
									<td>
										<p className={styles.price}>
											Fizetendő:
										</p>
									</td>
									<td colSpan="3">
										<p className={styles.underline}>
											25146 Ft
										</p>
									</td>
								</tr>
							</tbody>
						</table>
					)
					: null
			}
		</div>
	)
}

Table.propTypes = {
	invoiceData: PropTypes.objectOf().isRequired,
}

export default Table
